/* ASJ CUSTOM: accessible product-detail tabs (Description/Application/Technical Data/Testimonials).
   Progressive enhancement: panels render visible in HTML (readable with no JS); this script
   activates the first tab and wires click + full keyboard support (Arrow/Home/End). */
(function () {
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });

    function select(i, focus) {
      tabs.forEach(function (t, idx) {
        var sel = idx === i;
        t.setAttribute('aria-selected', sel ? 'true' : 'false');
        t.tabIndex = sel ? 0 : -1;
        if (panels[idx]) panels[idx].hidden = !sel;
      });
      if (focus) tabs[i].focus();
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { select((i + 1) % tabs.length, true); e.preventDefault(); }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { select((i - 1 + tabs.length) % tabs.length, true); e.preventDefault(); }
        else if (e.key === 'Home') { select(0, true); e.preventDefault(); }
        else if (e.key === 'End') { select(tabs.length - 1, true); e.preventDefault(); }
      });
    });

    select(0, false);
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-asj-tabs]')).forEach(initTabs);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();
